/**
 * inputMultiEmailDirective
 */

inputMultiEmailDirective.$inject = ['$app', '$mdConstant'];

export function inputMultiEmailDirective($app, $mdConstant) {
    return {
        //language=HTML
        template: `
            <md-input-container>
                <md-chips ng-model="value"
                          md-max-chips="{{ maxItems }}"
                          md-removable="true"
                          md-on-add="emailAdded($chip)"
                          md-enable-chip-edit="true"
                          md-add-on-blur="true"
                          md-separator-keys="separatorKeys"
                          aria-label="{{ label }}">
                    <input type="email"
                           placeholder="Enter an email address"
                           required>

                    <md-chip-template>{{ $chip }}</md-chip-template>
                </md-chips>

                <div class="hint" ng-if="(value.length < maxItems) && !(error)">
                    Separate emails with a comma.
                    {{ hint }}
                </div>

                <div class="hint" ng-if="value.length >= maxItems">
                    Maximum number of items has been reached
                </div>

                <div class="hint" ng-if="error">
                    {{ error }}
                </div>
            </md-input-container>
        `,
        scope: {
            form: '=form',
            hint: '@hint',
            label: '@label',
            maxItems: '=?maxItems',
            name: '@name',
            value: '=value',
        },
        link: function (scope, element) {
            element.addClass('app-form-field');

            const semicolon = 186;
            scope.separatorKeys = [
                $mdConstant.KEY_CODE.ENTER,
                $mdConstant.KEY_CODE.COMMA,
                semicolon,
            ];

            scope.value = Array.isArray(scope.value) ? scope.value : [];

            scope.emailAdded = _emailAdded;

            function _emailAdded($chip) {
                if (!basicEmailValidation($chip)) {
                    removeEmail($chip);
                    $app.errorToast('Email is not valid: ' + $chip);
                } else {
                    emailToLowerCase($chip);
                }
            }

            function basicEmailValidation(email) {
                const pattern = /^\S+@\S+\.\S+$/;

                return pattern.test(String(email).toLowerCase());
            }

            function removeEmail(email) {
                const index = scope.value.indexOf(email);

                if (index > -1) {
                    scope.value.splice(index, 1);
                }
            }

            function emailToLowerCase(email) {
                const index = scope.value.indexOf(email);

                if (index > -1) {
                    scope.value[index] = scope.value[index].toLowerCase();
                }
            }
        },
    };
}
